import { Card } from 'antd';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TableHeader from './components/TableHeader';
import Table from './components/tool/Table';
import { Paths } from 'constants/index';
import { Tool } from 'app/types/tool';

const List = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const showActive = pathname.includes(Paths.TOOLS_ACTIVE);

  // Set while the list is in report mode: the tools ticked for the report.
  const [ reportTools, setReportTools ] = useState<Tool[]>();

  useEffect(() => setReportTools(undefined), [ showActive ]);

  return (
    <>
      <Helmet title={`Kvalilog > ${t('entities.tools.title')}`} />
      <Card bordered={false} title={<TableHeader reportTools={reportTools} onReportToolsChange={setReportTools} />}>
        <Table showActive={showActive} reportTools={reportTools} onReportToolsChange={setReportTools} />
      </Card>
    </>
  );
};

export default List;
